import { isAndroid, isiOS, isPcApp } from '@/utils/runTimeEnv'
import { Toast } from 'vant'
import { isJsonString } from '@/utils/app-function'

/**
 * 定位获取城市 id
 * @param timeout 超时时间，默认 3000 ms
 * @returns Promise
 */
const defaultLocationInfo = {
  cityId: 1,
  city: '广州',
  isIPLocation: 0
}
export const getCityIdPromise = (timeout = 3000) =>
  Promise.race([
    new Promise(resolve => {
      let locationInfo: any = defaultLocationInfo
      // app定位
      if (isPcApp()) {
        // ios
        if (isiOS() && window?.webkit?.messageHandlers?.PCJSKit) {
          window.webkit.messageHandlers.PCJSKit.postMessage({
            functionName: 'locationInfo',
          })
          // android
        } else if (isAndroid() && window?.PCJSKit?.locationInfo) {
          locationInfo = window.PCJSKit.locationInfo()
          console.info('android定位= ', locationInfo)

          if (isJsonString(locationInfo)) {
            locationInfo = JSON.parse(locationInfo)
          }
          if (locationInfo?.cityId) {
            locationInfo = {
              cityId: locationInfo?.cityId || 0,
              city: locationInfo?.cityName || '',
              isIPLocation: locationInfo?.isIPLocation || 0
            }
          } else {
            locationInfo = defaultLocationInfo
          }
          resolve(locationInfo)

          // 默认城市
        } else {
          locationInfo = defaultLocationInfo
          Toast('请更新到最新版本app：定位')

          resolve(locationInfo)
        }


        // ios回调方法
        (window as any).locationInfo = (locationInfo: any) => {
          console.info('ios定位= ', locationInfo)

          if (isJsonString(locationInfo)) {
            locationInfo = JSON.parse(locationInfo)
          }
          if (locationInfo?.cityId) {
            locationInfo = {
              cityId: locationInfo?.cityId || 0,
              city: locationInfo?.cityName || '',
              isIPLocation: locationInfo?.isIPLocation || 0
            }
          } else {
            locationInfo = defaultLocationInfo
          }
          resolve(locationInfo)
        }
      } else {
        // h5 定位
        if (window.LocateAuto) {
          window.LocateAuto.init({
            device: 'wap',
            callback: (locationInfo: any) => {
              if (
                locationInfo?.cityId !== undefined &&
                locationInfo?.cityId !== null
              ) {
                locationInfo = {
                  cityId: locationInfo?.cityId || 0,
                  city: locationInfo?.city || '',
                  dataType: locationInfo?.dataType,
                  isIPLocation: locationInfo?.dataType === 'ipJson' ? 1 : 0
                }
              } else {
                locationInfo = defaultLocationInfo
              }
              resolve(locationInfo)
            }
          })
        } else {
          resolve({
            cityId: 1,
            city: '广州',
            dataType: 'default',
          })
        }
      }
    }),
    new Promise(resolve => {
      setTimeout(() => {
        resolve(defaultLocationInfo)
      }, timeout)
    }),
  ])